import styled from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import { useRef } from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import getId from '@userzoomlibraries/toolkit-js-utils/get-id';
import Backdrop from '@userzoomlibraries/toolkit-backdrop';
import Portal from '@userzoomlibraries/toolkit-portal';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { S as Spinner } from './index.styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["id", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SpinnerFullPage$1 = function SpinnerFullPage(_ref) {
  var id = _ref.id,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var spinnerFullPageId = useRef(id || "gz-spinner--full-page-".concat(getId()));
  var dataAttributes = useDataAttributes(rest);
  return /*#__PURE__*/jsxs(Portal, _objectSpread(_objectSpread({
    id: spinnerFullPageId.current,
    className: "gz-spinner--full-page ".concat(className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, dataAttributes), {}, {
    children: [/*#__PURE__*/jsx(Spinner, {}), /*#__PURE__*/jsx(Backdrop, {
      preventClose: true
    })]
  }));
};

SpinnerFullPage$1.COMPONENT_ID = 'Gearz.Spinner.FullPage';
SpinnerFullPage$1.displayName = SpinnerFullPage$1.COMPONENT_ID;
SpinnerFullPage$1.propTypes = {
  id: PropTypes.stringWithDescription('Id of the spinner.'),
  className: PropTypes.stringWithDescription('Custom class to be applied.')
};
SpinnerFullPage$1.defaultProps = {
  id: '',
  className: ''
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var SpinnerFullPage = styled(SpinnerFullPage$1).withConfig({
  componentId: "gz-spinner-1679042011568__sc-1ybt3xm-0"
})(["align-items:center;display:flex;height:100%;justify-content:center;left:0;position:fixed;top:0;width:100%;z-index:2000;", ""], function (props) {
  return getThemeByProps({
    componentId: SpinnerFullPage$1.COMPONENT_ID,
    props: props
  });
});
SpinnerFullPage.displayName = SpinnerFullPage$1.displayName;
SpinnerFullPage.propTypes = SpinnerFullPage$1.propTypes;
SpinnerFullPage.defaultProps = SpinnerFullPage$1.defaultProps;

export { SpinnerFullPage as S };
